import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-32 bg-gray-900 text-white overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col lg:flex-row items-center gap-20" data-id="element-11">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:w-1/2 w-full" data-id="element-12">
            <div className="relative" data-id="element-13">
              <div className="absolute -inset-4 bg-brand-gold/20 rounded-3xl transform rotate-3 blur-sm" data-id="element-14"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3VG5gjmchAC1JzyWMqm7vw/photo-output_copy.jpg" alt="Kareem Jamal" className="relative rounded-3xl shadow-2xl object-cover w-full h-[650px] bg-white" data-id="element-15" />
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4,
              duration: 0.6
            }} className="absolute -bottom-8 -right-8 bg-white text-gray-900 p-8 rounded-2xl shadow-2xl max-w-xs border border-gray-100" data-id="element-16">
                <p className="font-serif text-2xl mb-1" data-id="element-17">Rodeo Realty</p>
                <p className="text-xs text-gray-500 uppercase tracking-widest font-bold" data-id="element-18">
                  Fine Estates
                </p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:w-1/2" data-id="element-19">
            <h2 className="text-sm font-bold tracking-widest text-brand-gold uppercase mb-4" data-id="element-20">
              Your 91311 Facilitator
            </h2>
            <h3 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-10 leading-tight" data-id="element-21">
              Kareem Jamal
            </h3>

            <div className="space-y-8 text-gray-300 font-light text-lg leading-relaxed" data-id="element-22">
              <div className="relative" data-id="element-23">
                <span className="absolute -left-6 -top-4 text-6xl text-brand-gold/20 font-serif" data-id="element-24">
                  "
                </span>
                <p className="text-2xl text-brand-gold font-medium italic relative z-10 leading-relaxed" data-id="element-25">
                  I'm actively learning the full history and every pocket of
                  this zip as best I can. My mission is simple: help families
                  maintain and improve their personal residences so the whole
                  community stays strong.
                </p>
              </div>
              <p data-id="element-26">
                As your realtor, I'm the facilitator who makes that happen —
                whether it's strategic selling, smart upgrades, or positioning
                homes to protect equity and build long-term wealth.
              </p>
              <p data-id="element-27">
                From its roots as a Chumash village and the old West movie
                ranches, to the aerospace boom, 91311 has always been a place of
                growth. Today, it's a mature, proud suburban neighborhood where
                people invest in their homes.
              </p>
              <p data-id="element-28">
                Many homes here are 30–50 years old, presenting huge
                opportunities. I help families navigate the{' '}
                <strong className="text-white font-medium" data-id="element-29">
                  tax angles of improvements
                </strong>
                ,{' '}
                <strong className="text-white font-medium" data-id="element-30">
                  ADU additions
                </strong>
                , and strategic upgrades (kitchens, baths, outdoor spaces) to
                ensure their homes remain their greatest asset.
              </p>
            </div>

            <div className="mt-12 flex items-center space-x-10" data-id="element-31">
              <div className="flex flex-col" data-id="element-32">
                <span className="text-4xl font-serif text-brand-gold" data-id="element-33">
                  100+
                </span>
                <span className="text-xs text-gray-400 uppercase tracking-widest font-bold mt-2" data-id="element-34">
                  Families Helped
                </span>
              </div>
              <div className="w-px h-16 bg-gray-800" data-id="element-35"></div>
              <div className="flex flex-col" data-id="element-36">
                <span className="text-4xl font-serif text-brand-gold" data-id="element-37">
                  $50M+
                </span>
                <span className="text-xs text-gray-400 uppercase tracking-widest font-bold mt-2" data-id="element-38">
                  Volume Sold
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}